module.exports = {
    baseURL: JSON.parse('"https://partners.trustap.com"'),
    partnersBridgeBackendApiURL: JSON.parse('"https://pay.trustap.com"'),
    keycloakConfig: {
        realm: JSON.parse('"trustap"'),
        // This is the URL of the Keycloak server, in the form `<host>/auth` (e.g.
        // `https://sso.trustap.com/auth`).
        url: JSON.parse('"https://sso.trustap.com/auth"'),
        clientID: JSON.parse('"9e9ccc4b-1b85-42bc-aefa-13f399162419"')
    },
}
